<template>

  <div class="animated fadeIn">
    <b-row class="my-3">
      <b-col>
        <h4 class="text-center text-primary">
          <i class="fa fa-search text-primary mr-2"></i>
          Listado de Búsquedas
        </h4>
      </b-col>
    </b-row>

    <b-row md="12" class="pb-3">
      <b-col class="col-md-12">
        <b-row md="12">

          <b-card class="w-100">
            <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
              Búsquedas
              <div>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm mr-2"
                  @click="exportSearch('csv')">
                  <i class="fa fa-download"></i> CSV
                </button>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm"
                  @click="exportSearch('xlsx')">
                  <i class="fa fa-download"></i> Excel
                </button>
                <button
                  :disabled="count<1"
                  class="btn btn-primary btn-sm ml-2"
                  @click="exportSearch('pdf')">
                  <i class="fa fa-download"></i> PDF
                </button>
              </div>
            </b-row>
            <b-row md="12" class="mb-3 border-top-primary px-2">
              <b-col class="col-md-5">
                <b-form-group label="Buscar" :label-cols="3" :horizontal="true" class="w-100 mb-0">
                  <b-form-input
                    id="string"
                    name="string"
                    type="text"
                    placeholder="Busqueda general"
                    class="w-100"
                    v-validate="'min:3'"
                    aria-describedby="check_string"></b-form-input>
                  <div class="text-danger text-right" id="check_string">
                    <small>{{ errors.first('string') }}</small>
                  </div>
                </b-form-group>
              </b-col>

              <b-col class="col-md-5 clearfix"></b-col>

              <b-col class="col-md-2">
                <button
                  class="btn btn-pill btn-primary ml-4 float-right"
                  @click="search">Buscar Búsqueda
                </button>
              </b-col>

            </b-row>

            <v-server-table
              :columns="columns"
              :options="options"
              :theme="theme"
              class="dataTable"
              ref="dataTable"
              md="12"
              lg="12"
              sm="12"
              @sorted="tableSorted">
              <template slot="beforeBody">
                <tr v-if="loading">
                  <td class="text-center loading" colspan="7"><spinner size="medium" line-fg-color="#025542" line-bg-color="#c8ced3"></spinner></td>
                </tr>
              </template>
              <template slot="uuid" slot-scope="props">
                <router-link
                  v-b-tooltip.hover.top
                  title="Ver"
                  :to="{ name: 'searchOverview', params: { uuid: props.row.uuid  }}">
                  <i class="fa fa-eye"></i>
                </router-link>
              </template>
              <template slot="createdAt" slot-scope="props">  
                {{ props.row.createdAt | dateFormat('DD/MM/YYYY HH:mm') }}
              </template>
              <template slot="filters" slot-scope="props">
                {{ formatFields(props.row.filters) }}
              </template>
              <template slot="fields" slot-scope="props">
                {{ formatFields(props.row.fields) }}
              </template>
              <template slot="campaign" slot-scope="props">
                {{ props.row.campaign }}
              </template>
            </v-server-table>
          </b-card>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

  import Vue from 'vue';
  import Multiselect from 'vue-multiselect';
  import {setupCalendar, DatePicker} from 'v-calendar';
  import 'v-calendar/lib/v-calendar.min.css';
  import form from '@/helpers/form';
  import {ServerTable, Event} from 'vue-tables-2';
  import {downloadJsonAsCsv, downloadJsonAsXlsx} from '@/helpers/js-xlsx';
  import {downloadJsonAsPdf} from '@/helpers/js-pdf';
  import {getSearchFieldLists} from '@/api/search-api';
  import headquartersSelector from '@/components/headquarters/HeadquartersSelector';
  import Spinner from 'vue-simple-spinner';

  Vue.use(ServerTable);

  setupCalendar({
    firstDayOfWeek: 2,// Monday
  });

  export default {
    name: 'listPartners',
    components: {
      'v-date-picker': DatePicker,
      Multiselect,
      headquartersSelector,
      Spinner
    },
    data: function () {
      return {
        topmenu: [
          {
              name: 'Inicio',
              path: '/admin/dashboard',
              brand: 'fa fa-home'
          },
          {
              name: 'Crear Búsqueda',
              path: '/search/add',
              brand: 'fa fa-plus',
              permissions: ['REGISTER_MEMBER']
          },
        ],
        entity: {
          string: null,
          page: 1,
          itemsPerPage: 10,
        },
        orderBy: {
          column: null,
          ascending: null
        },
        count: 0,
        loading: true,
        columns: [
          'uuid',
          'createdAt',
          'entity',
          'filters',
          'fields',
          'campaign'
        ],
        options: {
          headings: {
            uuid: {
              text: '',
              id: 'fit'
            },
            createdAt: 'Fecha',
            entity: 'Entidad',
            filters: 'Filtros',
            fields: 'Campos',
            campaign: 'Distribución'
          },
          requestFunction: (data) => {
            if (this.$store.getters.getFilters[0] !== null) {
              this.entity.string = this.$store.getters.getFilters[0];
            }
            this.entity.page = data.page;
            this.entity.itemsPerPage = data.limit;
            return getSearchFieldLists(this.searchFilters);
          },
          responseAdapter: (data) => {
            return {
              data: data.searchFieldLists,
              count: data.count
            }
          },
          columnsClasses: {uuid: "fit"},
          sortable: ['createdAt'],
          filterable: false,
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          perPageValues: [10, 25, 50, 100, 500, 1000, 10000, 100000],
          texts: form.tableLabels(),
          pagination: {
            chunk: 10,
            edge: true,
            nav: 'scroll'
          }
        },

        theme: 'bootstrap4',
        template: 'default'
      }
    },
    mounted(){
      this.$eventHub.$emit('captureMenu', this.topmenu);
    },
    created() {
      this.options.texts = form.tableLabels();
      Event.$on('vue-tables.loading', (data) => {
        this.$_loadingMixin_showLoading();
        this.count = 0;
        this.loading = true;
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'none';
        }
      });
      Event.$on('vue-tables.loaded', (data) => {
        if (!!data && !!data.count) {
          this.count = data.count;
        }
        this.$_loadingMixin_hideLoading();
        this.loading = false;
        if (!!document.querySelector('.VueTables__no-results')) {
          document.querySelector('.VueTables__no-results').style.display = 'table-row';
        }
      });

    },
    computed: {
      searchFilters() {
        return {
          string: this.entity.string,
          page: this.entity.page,
          itemsPerPage: this.entity.itemsPerPage
        }
      }
    },
    methods: {
      formatFields(fields) {
        if (!fields) return '';
        
        // Split the fields by comma
        const fieldList = fields.split(',');
        
        // Capitalize the first letter of each word and add a space after each comma
        const formattedFields = fieldList.map((field) => {
          const trimmedField = field.trim();
          return trimmedField.charAt(0).toUpperCase() + trimmedField.slice(1);
        }).join(', ');

        return formattedFields;
      },
      search() {
        let filterData = [];
        filterData.push(this.entity.string);
        this.$store.commit('SET_FILTERS_LIST', filterData);
        this.$refs.dataTable.refresh();
      },
      validate() {
        // FIXME
        return true;
      },
      validateState(ref) {
        if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
          return !this.errors.has(ref);
        } else {
          return null;
        }
      },
      getMemberEmailsAsString(emails) {
        let string = '';
        if (Array.isArray(emails) && emails.length) {
          emails.forEach((email, index) => {
            string = string + (index > 0 ? '<br>' : '') + email.email;
          });
        }
        return string;
      },
      normalizeFieldList(field) {
        let groups = JSON.parse(field.searchData);
        let entity = [];
        let filters = [];
        let fields = [];
        groups.forEach((item) => {
          item.rows.forEach((row) => {
            entity.push(row.entity);
            filters.push(row.fieldCondition);
            fields.push(row.field);
          })
        });
        return {
          'Fecha': field.createdAt.toLocaleString(),
          'Entidad': entity.toString(),
          'Filtros': filters.toString(),
          'Campos': fields.toString(),
        }
      },
      async exportSearch(format) {
        if (this.count > 0) {
          this.$_loadingMixin_showLoading();

          let response = await axios({
            method: 'get',
            url: 'search',
            params: {
              page: 1,
              itemsPerPage: this.entity.itemsPerPage,
              string: this.entity.string
            }
          });

          let self = this;
          let rows = response.data.searchData.map(function (field) {
            return self.normalizeFieldList(field);
          });

          if (format === 'csv') {
            downloadJsonAsCsv(rows);
          } else if (format === 'xlsx') {
            downloadJsonAsXlsx(rows);
          } else if (format === 'pdf') {
            downloadJsonAsPdf(rows);
          }

          this.$_loadingMixin_hideLoading();
        }
      },
      tableSorted(data) {
        this.orderBy.column = data.column;
        this.orderBy.ascending = data.ascending;
      }
    },
  }
</script>

<style lang="scss">
  .VueTables__no-results {
    display: none;
  }
</style>
